import React from "react";
import styled, { keyframes } from "styled-components";
import { TextVariant, TypographyNew } from "../typography/typography";

const fadeInAndOut = keyframes`
  0% {
    opacity: 0;
  }
  25% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  75% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
`;

const Rotate = styled.div`
  animation: ${fadeInAndOut} 4s linear infinite;
  margin-left: 10px;
`;

type RequestInProgressProps = {
  className?: string;
};

const RequestInProgress = ({
  className,
}: RequestInProgressProps): JSX.Element => {
  return (
    <Rotate className={className}>
      <TypographyNew noWrap variant={TextVariant.h4}>{` . . . `}</TypographyNew>
    </Rotate>
  );
};

export default RequestInProgress;
